import VokalisSettingsService from '@baserow/modules/core/services/vokalisSettings'

export const state = () => ({
  hasToken: false,
  loaded: false,
})

export const mutations = {
  SET_HAS_TOKEN(state, hasToken) {
    state.hasToken = !!hasToken
    state.loaded = true
  },
}

export const actions = {
  async bootstrap({ state, commit }) {
    if (state.loaded) {
      return
    }
    try {
      const { data } = await VokalisSettingsService(this.$client).get()
      commit('SET_HAS_TOKEN', !!data?.has_token)
    } catch (error) {
      commit('SET_HAS_TOKEN', false)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
